import { AuthConstant } from '../constants';
import { RequestAction } from '.';

export const changePassword = data =>
  RequestAction.request(AuthConstant.CHANGE_PASSWORD, {
    data,
    method: 'post',
    url: '/api/change-password',
  });

export const forgotPassword = data =>
  RequestAction.request(AuthConstant.FORGOT_PASSWORD, {
    data,
    method: 'post',
    url: '/api/forgot-password',
  });

export const login = data =>
  RequestAction.request(AuthConstant.LOGIN, {
    data,
    method: 'post',
    url: '/api/login',
  });

export const logout = () => {
  storageRemoveAuth();
  return RequestAction.request(AuthConstant.LOGOUT, {
    method: 'post',
    url: '/api/logout',
  });
};

export const resetPassword = data =>
  RequestAction.request(AuthConstant.RESET_PASSWORD, {
    data,
    method: 'post',
    url: '/api/reset-password',
  });

export const setAuth = payload => {
  storageSetAuth(payload);
  return { payload, type: AuthConstant.SET_AUTH };
};

export const storageGetAuth = () => ({
  ...JSON.parse(localStorage.getItem(AuthConstant.KEY)),
});

export const storageRemoveAuth = () =>
  localStorage.removeItem(AuthConstant.KEY);

export const storageSetAuth = payload =>
  localStorage.setItem(
    AuthConstant.KEY,
    JSON.stringify({ ...storageGetAuth(), ...payload }),
  );
